import { Navigate, Route, Routes } from "react-router-dom";
import { LocationEditorPage } from "./LocationEditor";
import { LocationPolicyEditorPage } from "./LocationPolicyEditor";
import { PublicOfferingEditorPage } from "./PublicOfferingEditor";
import { VenueEditorPage } from "./VenueEditorPage";
import { VenuesPage } from "./VenuesPage";

export function VenuesRoutes() {
  return (
    <Routes>
      <Route index element={<VenuesPage />} />
      <Route path="new" element={<VenueEditorPage />} />
      <Route path=":venueId/edit" element={<VenueEditorPage />} />
      <Route path=":venueId/locations/new" element={<LocationEditorPage />} />
      <Route path=":venueId/locations/:locationId/edit" element={<LocationEditorPage />} />
      <Route
        path=":venueId/locations/:locationId/policies"
        element={<LocationPolicyEditorPage />}
      />
      <Route path=":venueId/offerings/new" element={<PublicOfferingEditorPage />} />
      <Route path="*" element={<Navigate to="/venues" replace />} />
    </Routes>
  );
}
